module.exports = __webpack_public_path__ + "static/img/driblab_fpbd.2167e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_fpbd.png
// module id = HLOm
// module chunks = 94